import { Component, HostBinding, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { RollupContentComponent } from '@fi-shared/rollup/rollup-content.component';

@Component({
    selector: 'fi-page-collapsable-content',
    templateUrl: './fi-page-collapsable-content.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fi-page-collapsable-content.component.scss'],
    host: { class: 'fi-page-collapsable-content' },
    standalone: false,
})
export class FiPageCollapsableContentComponent {
    @HostBinding('class.toggle-icon-position-right')
    @Input()
    toggleIconPositionRight = false;

    @ViewChild('rollupContent', { static: false }) rollupContent: RollupContentComponent;

    expandContent() {
        this.rollupContent.openContent();
    }
}
